module.exports = __webpack_public_path__ + "img/绑定微信.c99ab0f7.png";